<template>
  <div></div>
</template>
<script>
import { fetchHouseIds, fetchHouseDetail } from '@/services/mayilist'
import { errorReport } from '@/utils/index.js'
import mayiLogin from '@/utils/mayiLogin.js'
export default {
  mixins: [mayiLogin],
  components: {
  },
  data() {
    return {
      // 榜单中房屋数据
      houseData: [],
      // 房屋收藏关注数和状态
      favorFocus: null,
      // 防止重复点击收藏
      isClick: false
    }
  },
  props: {
    /**
     * [detail主接口comProps属性数据]
     */
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    /**
     * [组件所需数据体]
     */
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    /**
     * [组件索引]
     */
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    /**
     * [payload改变]
     * TODO: 调用去往cms详情页
     */
    payLoad(newVal) {
      if (newVal.type === 'location') {
        this.gotoDetail(newVal.data)
      }
    }
  },
  methods: {
    /**
     * [榜单初始化方法]
     */
    async init() {
      // 通过榜单id获取房屋id，
      const ids = [this.compProps.mate.activityId]
      const labelRes = await fetchHouseIds({ ids })
      if (labelRes.ret && labelRes.data && Array.isArray(labelRes.data)) {
        this.houseData = labelRes.data[0].houseData
        // lebelRes.data如果没有返回值，后续逻辑会报错，需要添加报警信息
        if (!labelRes.data[0]) {
          const url = window.location.href
          window._fas.setCustomError({
            message: `MServTopListComp: labelRes.data[0] is not defined`,
            level: 3,
            error: {
              url
            }
          })
        }
        try {
          const houseIdList = []

          this.houseData.forEach((item, index) => {
            // 只查询cms榜单中的前10个房屋详情（查询太多，时效太长）
            if (index <= 1) {
              houseIdList.push(item.id)
            }
          })
          // 无需报价
          const noNeedPrice = true
          // 展示下架房屋
          const needUnactive = true
          // 展示无库
          const needNoRepositoty = true
          // 通过房屋id获取房屋详情
          const houseRes = await fetchHouseDetail({ houseIdList, noNeedPrice, needUnactive, needNoRepositoty })

          if (houseRes.ret && houseRes.data) {
            // houseList Array类型
            const houseList = houseRes.data.items || []

            houseList.forEach((item, index) => {
              const idx = houseIdList.indexOf(item.unitId.toString())

              if (idx > -1) {
                this.houseData[idx].defaultPicture = item.pictureList ? item.pictureList[0] : item.defaultPicture
                this.houseData[idx].unitName = item.unitName
              }
            })
          }
          this.$emit('init', this.houseData)
        } catch (e) {
          console.log(e)
          errorReport(e)
        }
      }
    },
    /**
     * [去往cms详情页]
     * @param val 关于cmsid，like的数据集合
     */
    gotoDetail(val) {
      window.location.href = `${process.env.VUE_APP_M_MAYI_HOST}/modules/?id=${val.activityId}`
    },
    // 透传子servComp组件finish事件到UiComp组件
    finishHandle(payLoad) {
      this.$emit('finish', payLoad)
    }
  }
}
</script>
